import React, { useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { Spinner } from "evergreen-ui";
import { AppInputFieldSelect } from "../../../../../widget/styledComponents/input_field.style";



export const FETCH_BILLS_BY_PROPERTY = gql`
query Bills_getByProperty($propertyId: ID!, $status: BillStatusInput!) {
  bills_getByProperty(propertyId: $propertyId, status: $status) {
    _id
    due
    property
    payerType
    amount
    title
    description
    isRecurring
    nextPaymentDate
    status
    resident {
      _id
      name
      email
      address
    }
    owner {
      _id
      name
      email
      address
    }
    paidOn
    paidBy
    paidByType
    createdAt
    id
  }
}
`;


export default function SelectDue({ propertyId, onSelect }) {
  const { loading, error, data } = useQuery(FETCH_BILLS_BY_PROPERTY, {
    variables: { 
      propertyId,
      status:"all" 
    },
  });

  const [selectedDue, setSelectedDue] = useState("");

  if (loading) return <Spinner />;
  if (error) return <p>Error: {error.message}</p>;

  const duesOptions = data?.bills_getByProperty || [];

  const handleSelect = (event) => {
    const selectedValue = event.target.value;
    setSelectedDue(selectedValue);
    onSelect(selectedValue); // Pass selected due ID back to parent component
  };

  return (
    <div>
      <AppInputFieldSelect
        className="browser-default"
        required
        value={selectedDue}
        onChange={handleSelect}
      >
        <option value="" disabled>
          Choose a due
        </option>
        {duesOptions.map((due) => (
          <option key={due._id} value={due._id}>
            {due.title} - N{due.amount} 
          </option>
        ))}
      </AppInputFieldSelect>
    </div>
  );
}
